import { AreaOfLifeService } from '@app-services/area-of-life.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SessionService } from './session/session.service';
import { SessionStore } from './session/session.store';

import { FilterService } from '../services/filter.service';

import { FilterCompanyService } from '../services/filter-company.service';

@NgModule({
	declarations: [],
	imports: [CommonModule],
	providers: [
    SessionService,
    SessionStore,
    FilterCompanyService,
    FilterService,
    AreaOfLifeService
  ]
})
export class AppStoreModule {}
